import { Button } from 'src/v2/commonComponents/Button';
import { DotsThreeOutlineVertical } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import type { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';

export const ThreeDotsToggle = ({ id, disabled, onClick }: ToggleProps) => {
  return (
    <Button
      id={id}
      disabled={disabled}
      color="transparent"
      onClick={onClick}
      shape="round"
    >
      <DotsThreeOutlineVertical size={SVG_SIZE_M} />
    </Button>
  );
};
